import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DatabaseUtil from './Util/DatabaseUtil';
import SideBar from './Components/SideBar';
import CustomButton from './Components/Buttons'; 
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';


ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const DashUserDetail = () => {
    const { t } = useTranslation();

    const { userName } = useParams();
    const decodedUserName = decodeURIComponent(userName);

    const [userDetails, setUserDetails] = useState(null);
    const [subAccountDetails, setSubAccountDetails] = useState(null);
    const [lastPressedRole, setLastPressedRole] = useState(null);
    const [loading, setLoading] = useState(true); 
    const [subAccountLoading, setSubAccountLoading] = useState(false); 
    const [categoryStats, setCategoryStats] = useState({ views: {}, watchtime: {} });
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                setLoading(true);
                const details = await DatabaseUtil.getUserDetailsById(decodedUserName);
                setUserDetails(details);
            } catch (error) {
                console.error('Failed to fetch user details:', error);
                setError('Failed to load user details.');
            } finally {
                setLoading(false);
            }
        };

        fetchUserDetails();
    }, [decodedUserName]);

    const handleSubAccountClick = async (role) => {
        try {
            setSubAccountLoading(true);
            const details = 
                role === 'Student'
                    ? await DatabaseUtil.getMainAccountDetails(decodedUserName)
                    : await DatabaseUtil.getSubAccountDetails(decodedUserName, role);
            setSubAccountDetails({ ...details, role });
            setLastPressedRole(role);
            
            // Add category stats fetch here
            const stats = await DatabaseUtil.getUserCategoryStats(decodedUserName, role);
            setCategoryStats(stats);
        } catch (error) {
            console.error(`Failed to fetch ${role} details:`, error);
            setError(`Failed to load ${role} details.`);
        } finally {
            setSubAccountLoading(false);
        }
    };

    const blacklistedVideos = [
        'VideoAliENG', 'VideoAliESP',
        'VideoCamilaENG', 'VideoCamilaESP',
        'VideoJackENG', 'VideoJackESP',
        'VideoJessyENG', 'VideoJessyESP',
        'VideoJoseENG', 'VideoJoseESP',
        'VideoJuanENG', 'VideoJuanESP',
        'VideoLennyENG', 'VideoLennyESP',
        'VideoLindaENG', 'VideoLindaESP',
        'VideoMariaENG', 'VideoMariaESP',
        'VideoSelenaENG', 'VideoSelenaESP'
    ];

    const generateBarChartData = (topVideos) => {
        // Filter out blacklisted videos
        const filteredVideos = topVideos.filter(video => !blacklistedVideos.includes(video.videoId));
        
        const labels = filteredVideos.map(video => video.videoId);
        const data = filteredVideos.map(video => video.time);
    
        return {
            labels,
            datasets: [
                {
                    label: 'Watch Time',
                    data,
                    backgroundColor: '#FFFFFF',
                    borderColor: '#388e3c',
                    borderWidth: 0,
                },
            ],
        };
    };
    const generateCategoryViewsChartData = () => {
        return {
            labels: Object.keys(categoryStats.views).map(key => `Topic ${key}`),
            datasets: [{
                label: t('totalVideoViewsTopic'),
                data: Object.values(categoryStats.views),
                backgroundColor: '#FFFFFF',
                borderColor: '#FFFFFF',
                borderWidth: 0,
            }]
        };
    };
    
    const generateCategoryWatchtimeChartData = () => {
        return {
            labels: Object.keys(categoryStats.watchtime).map(key => `Topic ${key}`),
            datasets: [{
                label: t('avgWatchtimeTopic'),
                data: Object.values(categoryStats.watchtime),
                backgroundColor: '#FFFFFF',
                borderColor: '#FFFFFF',
                borderWidth: 0,
            }]
        };
    };

    const chartOptions = {
        plugins: {
            legend: {
                labels: {
                    color: '#ffffff', 
                    font: {
                        size: 16,
                        family: 'KomikaAxis'
                    },
                },
            },
            tooltip: {
                titleColor: '#ffffff', 
                bodyColor: '#ffffff',  
            },
            datalabels: {
                color: '#ffffff',
                anchor: 'end',
                align: 'end',
                formatter: (value) => value.toFixed(1),
                font: {
                    size: 8,
                    family: 'KomikaAxis'
                },
            },
        },
        scales: {
            x: {
                ticks: {
                    color: '#ffffff',
                    font: {
                        size: 12,
                        family: 'KomikaAxis'
                    },
                },
                

            },
            y: {
                ticks: {
                    color: '#ffffff', 
                    font: {
                        size: 12,
                        family: 'KomikaAxis'
                    },
                },
                
            },
        },
    };
        const watchtimeChartOptions = {
            ...chartOptions,
            scales: {
                ...chartOptions.scales,
                y: {
                    ...chartOptions.scales.y,
                    max: 100,
                }
            }
        };

    if (loading) return <p>Loading user details...</p>;
    if (error) return <p style={{ color: 'red' }}>{error}</p>;

    return (
        <>
            <SideBar /> 
            <div 
                style={{ 
                    display: 'flex', 
                    justifyContent: 'center',
                }}
            >
                <div 
                    style={{ 
                       /* backgroundColor: '#E0F7FA', // Light blue*/
                        /*padding: '20px', */
                       /* borderRadius: '10px', */
                       /* boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', */
                        width: '60%', 
                        display: 'flex', 
                        gap: '20px', 
                        /*alignItems: 'center', 
                        flexWrap: 'wrap', */
                        /*justifyContent: 'space-between',*/
                        /*marginLeft: '20px',
                        marginRight: '20px',*/
                        flexDirection: 'column',
                    }}
                >
                    {/* Avatar Icon */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px',marginTop: '20px' }}>
                    <img 
                        src={userDetails.avatarIcon} 
                        alt="User Avatar" 
                        style={{ 
                            width: '80px', 
                            height: 'auto', 
                            objectFit: 'cover', 
                            borderRadius: '50%',
                            border: '3px solid var(--primary-color)',
                        }}
                    />
                    <h2 style={{ margin: 0, marginBottom: '10px',color: 'var(--primary-color)' }}>{userDetails.userName}</h2>
                    </div>
                    {/* User Details */}
                    <div style={{ display: 'flex', gap: '20px' }}>
                        <div 
                            style={{ 
                                backgroundColor: 'var(--primary-color)', 
                                color: 'var(--primary-white-color)',
                                padding: '20px', 
                                borderRadius: '10px', 
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', 
                                textAlign: 'left',
                                flex: 1
                            }}
                        >
                            
                            <p style={{ margin: '5px 0' }}>{t('views')}: <strong>{userDetails.totalViews}</strong></p>
                            <p style={{ margin: '5px 0' }}>{t('avgWatchtime')}: <strong>{userDetails.averageWatchtime}%</strong></p>
                            <p style={{ margin: '5px 0' }}>{t('fullWatchRate')}: <strong>{userDetails.fullWatchRate}%</strong></p>
                            <div 
                        style={{
                            borderTop: '5px solid #FFFFFF',
                            borderRadius: '5px',   
                            margin: '5px 0',
                        }}
                    ></div>
                            <p style={{ margin: '5px 0' }}>{t('likes')}: <strong>{userDetails.totalLikes}</strong></p>
                            <p style={{ margin: '5px 0' }}>{t('comments')}: <strong>{userDetails.totalComments}</strong></p>

                        </div>
        
                        {/* Buttons */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <CustomButton
                                label={t('student')}
                                type={lastPressedRole === 'Student' ? 'secondary' : 'primary'}
                                onClick={() => handleSubAccountClick('Student')}
                                style={{ fontSize: '16px' }}
                            />
                            <CustomButton
                                label={t('caregiver')}
                                type={lastPressedRole === 'Caregiver' ? 'secondary' : 'primary'}         
                                onClick={() => handleSubAccountClick('Caregiver')} 
                                style={{ fontSize: '16px' }}
                            />
                            <CustomButton
                                label={t('teacher')}
                                type={lastPressedRole === 'Teacher' ? 'secondary' : 'primary'}  
                                onClick={() => handleSubAccountClick('Teacher')} 
                                style={{ fontSize: '16px' }}
                            />
                            <CustomButton
                                label={t('classmate')}
                                type={lastPressedRole === 'Classmate' ? 'secondary' : 'primary'}  
                                onClick={() => handleSubAccountClick('Classmate')} 
                                style={{ fontSize: '16px' }}
                            />
                        </div>
                    </div>

{/* Subaccount Details Panel */}
{subAccountLoading ? (
    <p>Loading subaccount details...</p>
) : subAccountDetails && (
                <div 
                    style={{ 
                        backgroundColor: 'var(--primary-color)',
                        color: 'var(--primary-white-color)',
                        padding: '20px', 
                        borderRadius: '10px',
                        textAlign: 'left',
                        marginTop: '20px',
                    }}
                >
                    <h3 style={{ margin: '10px 0' }}>{t(subAccountDetails.role.toLowerCase())} {t('details')}</h3>
                    <p style={{ margin: '5px 0' }}>{t('views')}: <strong>{subAccountDetails.totalViews}</strong></p>
                    <p style={{ margin: '5px 0' }}>{t('avgWatchtime')}: <strong>{subAccountDetails.averageWatchtime}%</strong></p>
                    <p style={{ margin: '5px 0' }}>{t('fullWatchRate')}: <strong>{subAccountDetails.fullWatchRate}%</strong></p>
                    <div 
                        style={{
                            borderTop: '5px solid #FFFFFF',
                            borderRadius: '5px',   
                            margin: '5px 0',
                        }}
                    ></div>
                    <p style={{ margin: '5px 0' }}>{t('likes')}: <strong>{subAccountDetails.totalLikes}</strong></p>
                    <p style={{ margin: '5px 0' }}>{t('comments')}: <strong>{subAccountDetails.totalComments}</strong></p>
                </div>
            )}
            
                        {/* Chart for most watched videos, doesn't show if no role has been selected */}
                        {subAccountDetails?.topVideos?.length > 0 || userDetails?.topVideos?.length > 0 ? (
                <div 
                    style={{ 
                        backgroundColor: 'var(--primary-color)', 
                        color: 'var(--primary-white-color)', 
                        padding: '20px', 
                        borderRadius: '10px', 
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', 
                        /*width: '50%', */
                        textAlign: 'center',
                        /*marginLeft: '50px',*/
                    }}
                >
                    <div style={{ marginTop: '20px' }}>
                        <Bar 
                            data={generateBarChartData(
                                subAccountDetails?.topVideos || userDetails?.topVideos
                            )} 
                            options={chartOptions}
                            plugins={[ChartDataLabels]}
                            /*height={125} */

                        />
                    </div>
                    <div 
                        style={{
                            borderTop: '5px solid #FFFFFF',
                            borderRadius: '5px',   
                            margin: '5px 0',
                        }}
                    ></div>
                    {subAccountDetails && Object.keys(categoryStats.views).length > 0 && (
                <>
                    <div 
                        style={{ 
                            backgroundColor: 'var(--primary-color)', 
                            /*padding: '20px',*/
                            borderRadius: '8px',
                            color: 'white',
                            /*width: '90%',
                            marginLeft: '50px',
                            marginTop: '20px'*/
                        }}
                    >
                        
                        <Bar 
                            data={generateCategoryViewsChartData()} 
                            options={chartOptions} 
                            plugins={[ChartDataLabels]}
                        />
                    </div>
                    <div 
                        style={{
                            borderTop: '5px solid #FFFFFF',
                            borderRadius: '5px',   
                            margin: '5px 0',
                        }}
                    ></div>
                    <div 
                        style={{ 
                            backgroundColor: 'var(--primary-color)', 
                            padding: '20px',
                            borderRadius: '8px',
                            color: 'white',
                            /*width: '90%', 
                            marginLeft: '50px',
                            marginTop: '20px'*/
                        }}
                    >
                       
                        <Bar 
                            data={generateCategoryWatchtimeChartData()} 
                            options={watchtimeChartOptions} 
                            plugins={[ChartDataLabels]}
                        />
                    </div>
                        </>
                    )}
                </div>
                
            ) : null} 
                </div>
            </div>
        </>
    );
};

export default DashUserDetail;
